import type {ReactElement} from 'react';
import React from 'react';
import App from '@Components/app';
import {LoadingToast} from '@Components/loading-toast';
import {createRoot} from 'react-dom/client';
import type {PosterOpts} from '@PosterWhiteboard/poster/poster.class';
import {PosterWebpageFullscreen} from '@Components/poster-webpage-fullscreen';
import type {PosterWebPageConfig} from '@Components/poster-webpage';
import {EmbeddedPoster} from '@Components/embedded-poster';
import {useLoadI18} from '@Hooks/useLoadI18';
import {renderApp} from '@Utils/renderApp.util';

interface ReactPageProps {
  isEmbbed: boolean;
  posterWebPageConfig: PosterWebPageConfig;
  posterOpts: PosterOpts;
}

const reactPageProps = window.reactPageProps as ReactPageProps;

function PosterMakerApp(): ReactElement<any> | null {
  const i18Loaded = useLoadI18();

  if (!i18Loaded) {
    return <App />;
  }

  const getPoster = (): ReactElement<any> => {
    return reactPageProps.isEmbbed ? (
      <EmbeddedPoster posterOpts={reactPageProps.posterOpts} />
    ) : (
      <PosterWebpageFullscreen posterWebPageConfig={reactPageProps.posterWebPageConfig} posterOpts={reactPageProps.posterOpts} />
    );
  };

  return (
    <App nonStrickModeChildren={getPoster()}>
      <LoadingToast />
    </App>
  );
}

renderApp(<PosterMakerApp />, 'pmw-app');
